import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';

export const GoalsApp: ComponentType<unknown> & LoadableExport.LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "goals-app-entry" */ '@townsquare/goals/app'),
	loading: () => null,
});
